import { useQuery } from '@tanstack/react-query';
import { getTaskManagerTasks } from 'API/linkedin-funnel';
import { useUserData } from 'hooks/use-user-data';

/**
 * Anzahl offener Aufgaben (Konten reparieren, Nachrichten freigeben, Antworten) für den
 * Zähler in der Navigation. Der Schlüssel beginnt mit 'tasks', damit jedes
 * invalidateQueries({ queryKey: ['tasks'] }) nach einer Freigabe den Zähler mitzieht.
 *
 * `funnelType` trennt Recruiting und Sales; ohne ihn zählte der Recruiting-Zähler auch
 * jede Sales-Aufgabe mit.
 */
const useOpenTaskCount = (enabled: boolean, funnelType?: string) => {
  const { token } = useUserData();

  const { data } = useQuery({
    queryKey: ['tasks', 'openCount', token, funnelType],
    queryFn: ({ signal }) => getTaskManagerTasks(funnelType, 'all', [], true, signal),
    select: (res) => res?.totalCount ?? 0,
    refetchInterval: 2 * 60 * 1000,
    staleTime: 60 * 1000,
    enabled: enabled && !!token,
    // Ein Zähler darf nie einen Fehlerdialog auslösen.
    retry: false,
  });

  return data ?? 0;
};

export default useOpenTaskCount;
